    <template>
    <menu_items :menu_items="menu_items"
                initial_item="explosives"
    />
</template>

<script>

import menu_items from '../../components/menu.vue';
import explosives from './_1_explosives/index';
import flammable_gases from './_2_flammable_gases/index';
import unstable_gases from './_3_unstable_gases/index';
import aerosols from './_4_aerosols/index';
import oxidizing_gases from './_5_oxidizing_gases/index';
import gases_under_pressure from './_6_gases_under_pressure/index';
import flammable_liquids from './_7_flammable_liquids/index';
import flammable_solids from './_8_flammable_solids/index';
import spontaneous_reacting_substances from './_9_spontaneous_reacting_substances/index';
import pyrophoric_liquids from './_10_pyrophoric_liquids/index';
import pyrophoric_solids from './_11_pyrophoric_solids/index';
import spontaneous_heating_substances from './_12_spontaneous_heating_substances/index';
import flammable_gases_with_water_contact from './_13_flammable_gases_with_water_contact/index';
import oxidizing_liquids from './_14_oxidizing_liquids/index';
import oxidizing_solids from './_15_oxidizing_solids/index';
import organic_peroxides from './_16_organic_peroxides/index';
import corrosive_substances_mixtures from './_17_corrosive_substances_mixtures/index';
import desensitized_explosives from './_18_desensitized_explosives/index';

export default {
    name: 'index',
    components: {
        menu_items,
        explosives,
        flammable_gases,
        unstable_gases,
        aerosols,
        oxidizing_gases,
        gases_under_pressure,
        flammable_liquids,
        flammable_solids,
        spontaneous_reacting_substances,
        pyrophoric_liquids,
        pyrophoric_solids,
        spontaneous_heating_substances,
        flammable_gases_with_water_contact,
        oxidizing_liquids,
        oxidizing_solids,
        organic_peroxides,
        corrosive_substances_mixtures,
        desensitized_explosives
    },
    data() {
        return {
            menu_items: [
                {
                    name: 'explosives',
                    text: 'Explosivos',
                    component: explosives,
                    image: 'BOMBA_EXPLOTANDO.png'
                },
                {
                    name: 'flammable_gases',
                    text: 'Gases inflamables',
                    component: flammable_gases,
                    image: 'LLAMA.png'
                },
                {
                    name: 'aerosols',
                    text: 'Aerosoles',
                    component: aerosols,
                    image: 'LLAMA.png'
                },
                {
                    name: 'oxidizing_gases',
                    text: 'Gases comburentes',
                    component: oxidizing_gases,
                    image: 'LLAMA_SOBRE_CIRCULO.png'
                },
                {
                    name: 'gases_under_pressure',
                    text: 'Gases a presión',
                    component: gases_under_pressure,
                    image: 'BOTELLA_DE_GAS.png'
                },
                {
                    name: 'flammable_liquids',
                    text: 'Líquidos inflamables',
                    component: flammable_liquids,
                    image: 'LLAMA.png'
                },
                {
                    name: 'flammable_solids',
                    text: 'Sólidos inflamables',
                    component: flammable_solids,
                    image: 'LLAMA.png'
                },
                {
                    name: 'spontaneous_reacting_substances',
                    text: 'Sustancias que reaccionan espontáneamente (autorreactivas)',
                    component: spontaneous_reacting_substances,
                    image: 'BOMBA_EXPLOTANDO_LLAMA.png'
                },
                {
                    name: 'pyrophoric_liquids',
                    text: 'Líquidos pirofóricos',
                    component: pyrophoric_liquids,
                    image: 'LLAMA.png'
                },
                {
                    name: 'pyrophoric_solids',
                    text: 'Sólidos pirofóricos',
                    component: pyrophoric_solids,
                    image: 'LLAMA.png'
                },
                {
                    name: 'spontaneous_heating_substances',
                    text: 'Sustancias que experimentan calentamiento espontaneo',
                    component: spontaneous_heating_substances,
                    image: 'LLAMA.png'
                },
                {
                    name: 'flammable_gases_with_water_contact',
                    text: 'Sustancias que en contacto con el agua, desprenden gases inflamables',
                    component: flammable_gases_with_water_contact,
                    image: 'LLAMA.png'
                },
                {
                    name: 'oxidizing_liquids',
                    text: 'Líquidos comburentes',
                    component: oxidizing_liquids,
                    image: 'LLAMA_SOBRE_CIRCULO.png'
                },
                {
                    name: 'oxidizing_solids',
                    text: 'Sólidos comburentes',
                    component: oxidizing_solids,
                    image: 'LLAMA_SOBRE_CIRCULO.png'
                },
                {
                    name: 'organic_peroxides',
                    text: 'Peróxidos orgánicos',
                    component: organic_peroxides,
                    image: 'BOMBA_EXPLOTANDO_LLAMA.png'
                },
                {
                    name: 'corrosive_substances_mixtures',
                    text: 'Sustancias y mezclas corrosivas para los metales',
                    component: corrosive_substances_mixtures,
                    image: 'CORROSION.png'
                },
                {
                    name: 'desensitized_explosives',
                    text: 'Explosivos insensibilizados',
                    component: desensitized_explosives,
                    image: 'LLAMA.png'
                }
            ],
        };
    }
};
</script>

<style>

</style>
